import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";

const NebulaUltraTransactions = React.lazy(() => import('../NebulaUltraTransactions'));
const nebulaUltraTransactionsRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_ULTRA_TRANSACTIONS_PAGE,
        element: <NebulaUltraTransactions />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];
export default nebulaUltraTransactionsRoutesRegistry;
